import { useCallback } from "react";
import {
    useSnackbar as useNotistackSnackbar,
    OptionsObject,
    SnackbarKey,
    SnackbarMessage,
} from "notistack";

export * from "notistack";

const FALLBACK_MESSAGE = "Something went wrong.";

export const useSnackbar = () => {
    const { enqueueSnackbar, ...rest } = useNotistackSnackbar();
    const safeEnqueueSnackbar = useCallback(
        (message?: SnackbarMessage, options?: OptionsObject): SnackbarKey =>
            enqueueSnackbar(message ?? FALLBACK_MESSAGE, options),
        [enqueueSnackbar],
    );
    return {
        ...rest,
        enqueueSnackbar: safeEnqueueSnackbar,
    };
};
